import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";

import { selectElement, clearSelectedElement } from "../actions/selectActions";
import "../styles/element.scss";

class Element extends Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  handleClick = () => {
    if (this.props.selected) {
      this.props.clearSelectedElement();
    } else {
      this.props.selectElement(this.props.symbol);
    }
  };

  render() {
    return (
      <div
        className={classnames("element", {
          "element--selected": this.props.selected
        })}
        onClick={!this.props.special ? this.handleClick : () => {}}
      >
        <div
          className={classnames(
            "element--title",
            "element--" + this.props.symbol,
            { "element--title--big": this.props.big },
            { "element--title--pure": this.props.pure },
            { "element--title--special": this.props.special }
          )}
        >
          {this.props.atomicNumber}
        </div>
        <div
          className={classnames(
            "element--content",
            "element--" + this.props.symbol,
            { "element--content--big": this.props.big },
            { "element--content--pure": this.props.pure },
            { "element--content--special": this.props.special }
            //{ "center-vertical": this.props.special }
          )}
        >
          {this.props.symbol}
        </div>
        {this.props.tellurium && (
          <div className="element--indicator element--indicator--tellurium" />
        )}
        {this.props.other && (
          <div className="element--indicator element--indicator--other" />
        )}
        {this.props.fluorine && (
          <div className="element--indicator element--indicator--fluorine" />
        )}
        {this.props.nitrogen && (
          <div className="element--indicator element--indicator--nitrogen" />
        )}
        {this.props.oxygen && (
          <div className="element--indicator element--indicator--oxygen" />
        )}
        {this.props.sulfur && (
          <div className="element--indicator element--indicator--sulfur" />
        )}
        {this.props.selenium && (
          <div className="element--indicator element--indicator--selenium" />
        )}
      </div>
    );
  }
}

export default connect(
  null,
  { selectElement, clearSelectedElement }
)(Element);
